// extracted by mini-css-extract-plugin
export default {"main":"main_main__P1lma","moduleNameHeader":"main_moduleNameHeader__rR5Fk","moduleNameHeaderTitle":"main_moduleNameHeaderTitle__Ev+9H"};